export default {
  downForMaintenance: "DeltaOS is currently down for maintenance, we will be back soon.",
  salesQueries: "For any sales queries, please get in touch with our ",
  salesTeam: "sales team",
};
